import React, { useRef, useEffect, useState } from 'react';
import { useInterest } from '../../context/InterestContext';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import ReCAPTCHA from 'react-google-recaptcha';

import './contact.css'
import {MdOutlineMarkEmailRead} from 'react-icons/md'
import {FaWhatsapp} from 'react-icons/fa'
import AVTR5 from '../../assets/Techomp_javier_arzate.png'
import QRJavier from '../../assets/QR-javier.jpg'
import {BsWhatsapp} from 'react-icons/bs'

const SITE_KEY = '6LfqKnksAAAAAJWoTV-o6GQIQ0vbCs_RxjFc_lK5';

const TITLE_TO_OPTION = {
  "Ultracongelador EVOLUTION 690 L": "Ultracongelador EVOLUTION 690 L",
  "Ultracongelador TRUST 690 L": "Ultracongelador TRUST 690 L",
  "Horno de Convección Forzada Air Expert 240 L": "Horno Air Expert 240L",
  "Incubadora de Convección ForzadaBio Expert 240 L": "Incubadora Bio Expert 240L",
};

const OPTIONS = [
  'Ultracongelador EVOLUTION 690 L',
  'Ultracongelador TRUST 690 L',
  'Horno Air Expert 240L',
  'Incubadora Bio Expert 240L',
  'Nuevos productos',
  'Friolabo',
  'Precisa',
  'Scion Instruments',
  'Dynamica',
];

const Contact = () => {
  const { interest } = useInterest();


  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    if (!interest) return;

    const mapped = TITLE_TO_OPTION[interest] || interest;

    setSelectedOptions((prev) => {
      if (prev.includes(mapped)) return prev;
      return [...prev, mapped];
    });

    // Opcional: precargar textarea
    // setMessage(`Me gustaría tener un precio especial en este producto: ${mapped}`);
  }, [interest]);

  const form = useRef();
  const recaptchaRef = useRef(null);

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [isSending, setIsSending] = useState(false);

  const toggleOption = (opt) => {
    setSelectedOptions((prev) =>
      prev.includes(opt) ? prev.filter((x) => x !== opt) : [...prev, opt]
    );
  };


  const sendEmail = async (e) => {
    e.preventDefault();

    // reCAPTCHA obligatorio
    if (!recaptchaToken) {
      Swal.fire({
        icon: 'warning',
        title: 'Verificación requerida',
        text: 'Por favor, completa el reCAPTCHA antes de enviar.',
        confirmButtonColor: '#043268',
      });
      return;
    }

    // (Opcional) obliga a seleccionar al menos 1 interés
    if (selectedOptions.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Falta selección',
        text: 'Selecciona al menos una opción de interés.',
        confirmButtonColor: '#043268',
      });
      return;
    }

    try {
      setIsSending(true);

      await emailjs.sendForm('service_mgrekyi', 'template_npnrjr4', form.current, {
        publicKey: 'PLVe2mPiaHGqH25Tp',
      });

      Swal.fire({
        icon: 'success',
        title: 'Mensaje enviado',
        text: 'Tu mensaje ha sido enviado con éxito.',
        confirmButtonColor: '#043268',
      });

      // Reset
      form.current.reset();
      setSelectedOptions([]);
      setRecaptchaToken(null);
      recaptchaRef.current?.reset();
    } catch (error) {
      console.log('FAILED...', error);

      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Hubo un error al enviar el mensaje. Por favor, inténtalo de nuevo más tarde.',
        confirmButtonColor: '#043268',
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section id='contact'>
      <h3 className='title-contact'>Póngase en contacto</h3>
      <h2 >Estamos para servirle</h2><br />

      <div className="container contact__container">

        
      <form ref={form} onSubmit={sendEmail}>
          <div className="input-row">
              <input type="text" name='name' placeholder='Nombre Completo' className='placeholder' required />
              <input type="email" name="email" placeholder='Correo electrónico' className='placeholder' required />
          </div>
          <div className="input-row">
              <input type="text" name='empresa' placeholder='Empresa' className='placeholder' required />
              <input type="text" name='phone' placeholder='Teléfono' className='placeholder' maxLength={10} required />
          </div>

          <div className="contact__fieldset">
            <p className="contact__label">Seleccione la opción de su interés</p>

            <div className="checkbox-grid" role="group" aria-label="Seleccione la opción de su interés">
              {OPTIONS.map((opt) => {
                const id = `opt-${opt.replace(/\s+/g, '-').toLowerCase()}`;
                const checked = selectedOptions.includes(opt);

                return (
                  <label key={opt} className={`checkbox-item ${checked ? 'is-checked' : ''}`} htmlFor={id}>
                    <input
                      id={id}
                      type="checkbox"
                      checked={checked}
                      onChange={() => toggleOption(opt)}
                    />
                    <span className="checkbox-custom" aria-hidden="true" />
                    <span className="checkbox-text">{opt}</span>
                  </label>
                );
              })}
            </div>

            {/* Lo que se manda a EmailJS */}
            <input type="hidden" name="interes" value={selectedOptions.join(', ')} />
          </div>

          <textarea name="message" rows="7" placeholder='Comentarios o notas sobre su solicitud.' className='placeholder' required></textarea>

          <div style={{ margin: '14px 0' }}>
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={SITE_KEY}
              onChange={(token) => setRecaptchaToken(token)}
              onExpired={() => setRecaptchaToken(null)}
            />
          </div>

          <button type="submit" className="btn-secondary" disabled={isSending}>
            {isSending ? 'Enviando...' : 'Enviar'}
          </button>
      </form>

        <div className="contact__options">
          <article className="contact__option">
            <div className="qr">
              <img src={QRJavier} alt="" style={{borderRadius:'30px'}} />
            </div>
            <h4>Javier Arzate</h4>
            <a href="https://api.whatsapp.com/send?phone=5546208617&text=Hola,%20*¡Quiero%20cambiar%20mi%20ultracongelador!*" target="_blank" className='btn-wts'><BsWhatsapp/> Whatsapp</a> <br />
            <a className='btn btn-primary' href='tel:5570081678'>Contáctame</a>
          </article>
        </div>

      </div>
    </section>
  )
}

export default Contact